exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1xNzYy0NvHIS1RIGX4VKeW{white-space:nowrap}._1ExaYwQ4909WjdZaDfTc1T{display:inline-block;max-width:7.85714rem;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;vertical-align:bottom}", ""]);

// exports
exports.locals = {
	"QuickSummary": "_1xNzYy0NvHIS1RIGX4VKeW",
	"QuickSummary_unit": "_1ExaYwQ4909WjdZaDfTc1T"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/QuickSummary/style.postcss
// module id = 1342
// module chunks = 0